import * as React from "react";
import type { Strategy } from "@/data/types";
import { Reveal, Overline } from "./primitives";
import { StrategyStage } from "./StrategyStage";

interface Props {
  strategy: Strategy;
}

export const RelaunchStrategy: React.FC<Props> = ({ strategy }) => {
  if (!strategy?.stages?.length) return null;

  return (
    <section
      className="w-full bg-ivory py-20 md:py-28"
      data-testid="relaunch-strategy"
      aria-label="My relaunch strategy"
    >
      <div className="mx-auto w-full max-w-5xl px-6 md:px-10">
        <Reveal>
          <Overline>What I would change — and why</Overline>
          <h2 className="mt-4 max-w-2xl font-serif text-3xl leading-tight text-charcoal md:text-4xl lg:text-5xl">
            A relaunch that feels meaningfully different.
          </h2>
          {strategy.intro && (
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-charcoal-soft md:text-lg">
              {strategy.intro}
            </p>
          )}
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-x-14 gap-y-12 md:grid-cols-2">
          {strategy.stages.map((stage, i) => (
            <Reveal key={stage.key} delay={(i % 2) * 0.1}>
              <StrategyStage stage={stage} />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
